<template>
  <div style="background-color:#f5f5f5">
    <div class="cont" style="padding-top:29px;padding-bottom:20px">
      <div style="color:#FF6600;margin-bottom:29px;display:flex;align-items:center">
        <el-image
          style="height:20px;width:20px;margin-right:5px"
          class="product_image"
          :src=' u1562 '
          fit="contain"
        ></el-image>
        请注意核对产品对应车型，街道用产品不能在赛道使用。
      </div>
      <div style="color:#999999;margin-bottom:29px">填写订单信息</div>

      <div style="padding:24px 50px;box-sizing:border-box;background-color:#fff;">
        <div style="margin-bottom:13px;color:#666">收货地址</div>
        <div style="border: 1px solid rgb(228, 228, 228);padding:33px 30px;box-sizing:border-box;display:flex;">
          <div style="flex:1;">
            <div style="margin-bottom:15px">
              <span style="width:90px;;display:inline-block;font-size: 14px;color: #999999">
                收货人:
              </span>
              <span style="font-size: 14px;color: #666666;">
                {{ userAddress.name ? userAddress.name : '请添加地址'  }}
              </span>
            </div>
            <div style="margin-bottom:15px">
              <span style="width:90px;;display:inline-block;font-size: 14px;color: #999999">
                联系方式:
              </span>
              <span style="font-size: 14px;color: #666666;">
                {{ userAddress.phone ? userAddress.phone : '请添加地址' }}
              </span>

            </div>
            <div>
              <span style="width:90px;display:inline-block;font-size: 14px;color: #999999">
                收货地址:
              </span>
              <span style="font-size: 14px;color: #666666;">
                {{ userAddress.provName ? userAddress.provName +  userAddress.cityName + userAddress.distName + userAddress.detail : '请添加地址' }}
              </span>

            </div>
          </div>

          <div style="border-right:1px solid lightgray;display:flex;align-items:center;padding-right:57px;margin-right:37px">
            <el-button type="text" @click="changeAddress">修改地址</el-button>
          </div>

          <div style="display:flex;align-items:center;">
            <div
              @click="addressChangeClick"
              class="background_style btn"
              :style="{backgroundImage: 'url(' + btn_black_toggle + ')' }"
              style="display:inline-block;width:168px;height:36px;line-height:36px;cursor : pointer"
            >
            </div>

            <div
              @click="addressClick"
              class="background_style btn"
              :style="{backgroundImage: 'url(' + btn_black_change + ')' }"
              style="display:inline-block;width:168px;height:36px;line-height:36px;cursor : pointer"
            >
            </div>
          </div>

        </div>
        <div v-if="orderType==0">
          <div style="margin:30px 0 13px;color:#666">收货选择：
            <el-radio v-model="receiptType" @change="receiptTypeChange" label="1" border size="medium">数量优先</el-radio>
            <el-radio style="margin-left: 10px" v-model="receiptType" @change="receiptTypeChange" label="2" border size="medium">距离优先</el-radio>
          </div>
        </div>

        <div style="color:#323233;margin-bottom:10px;margin-top:10px;display:flex;align-items:center;background-color:#fefdeb;padding:15px">
          温馨提示：刹车油、消音膏、螺丝胶暂不支持空运
        </div>
        <div  v-for="(subGoods,index1_) in subWarehouseGoods" :key='index1_'>
            <div  class="background_style btn" :style="{backgroundImage: 'url(' + btn_red + ')' }"
            style="display:inline-block;height:30px;line-height:30px;margin-bottom: 5px;margin-top: 5px;" >
              发货仓:{{subGoods.subWarehouse.subWarehouseName}}
            </div>
          <div style="box-sizing:border-box;background-color:#fff;">
          <el-table ref="multipleTable" :data="subGoods.apiGoods" tooltip-effect="dark"
            style="width: 100% ; border:1px solid #e4e4e4 " :row-style="{height: '90px'}"
            :header-cell-style="{background:'#f9f9f9' , height : '50px'}" >
            <el-table-column label="商品信息"  align="center">
              <template slot-scope="scope">
                <div style="display:flex;   	">
                  <el-image style="width: 50px; height: 50px" :src="publicUrl +  scope.row.apiGoodsSpec.goodsPic" fit="contain"></el-image>
                  <div
                    style="flex:1;margin-left:15px;display:flex;flex-direction:column;justify-content:center;text-align:left"
                  >
                    <div
                      style="font-size: 14px;font-weight: 700;color: #333333;"
                      v-if="moduleUser.goods_visible == '1' "
                    >{{ scope.row.goodsName }}</div>
                    <div
                      style="font-size: 14px;font-weight: 700;color: #333333;"
                      v-else-if="moduleUser.goods_visible == '0' "
                    >{{ scope.row.goodsErp.specification }}</div>
                    <div style="color:#999999;font-size: 12px;text-align: left;"> {{ scope.row.apiTempOrder.searchValue?'适配：'+scope.row.apiTempOrder.searchValue:'' }} </div>
                    <div style="color:#999999;font-size: 12px;text-align: left;"> {{ scope.row.apiTempOrder.vin?'车架号：'+scope.row.apiTempOrder.vin:'' }} </div>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="price" label="单价" width="250" align="center">
              <template slot-scope="scope">
                <div style="display:flex;justify-content:center">

                  <div style="color: #7F7F7F;">
                    <div>零售价</div>
                    <div>{{ scope.row.apiGoodsSpec.goodsPrice  ? '¥' + scope.row.apiGoodsSpec.goodsPrice  : ''  }}</div>
                  </div>
                  <div style="color: #E60012;margin-left:20px"  v-if="scope.row.promotionStatus==1">
                    <div  style="text-decoration: line-through;">拿货价</div>
                    <div  style="text-decoration: line-through;">{{ scope.row.apiGoodsSpec.discountPrice  ? '¥' + scope.row.apiGoodsSpec.discountPrice  : '已失效'  }}</div>
                  </div>
                  <div style="color: #E60012;margin-left:20px"  v-if="scope.row.promotionStatus==1">
                    <div>活动价</div>
                    <div>{{ scope.row.promotionPrice  ? '¥' + scope.row.promotionPrice  : '已失效'  }}</div>
                  </div>

                  <div style="color: #E60012;margin-left:20px"  v-if="scope.row.promotionStatus!=1">
                    <div>拿货价</div>
                    <div>{{ scope.row.apiGoodsSpec.discountPrice  ? '¥' + scope.row.apiGoodsSpec.discountPrice  : '已失效'  }}</div>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="num" label="数量"  width="120" align="center">
              <template slot-scope="scope">
                X {{ scope.row.apiTempOrder.quantity }}
              </template>
            </el-table-column>

            <el-table-column prop="price" label="小计" width="120" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.promotionStatus==1">{{ (scope.row.apiTempOrder.quantity * scope.row.promotionPrice).toFixed(2) }}</span>
                <span v-if="scope.row.promotionStatus!=1">{{ (scope.row.apiTempOrder.quantity * scope.row.apiGoodsSpec.discountPrice).toFixed(2) }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="price" label="实付" width="120" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.promotionStatus==1">{{ (scope.row.apiTempOrder.quantity * scope.row.promotionPrice).toFixed(2) }}</span>
                <span v-if="scope.row.promotionStatus!=1">{{ (scope.row.apiTempOrder.quantity * scope.row.apiGoodsSpec.discountPrice).toFixed(2) }}</span>
              </template>
            </el-table-column>

          </el-table>

            <div style="margin:30px 0;color:#666">{{subGoods.subWarehouse.subWarehouseName}}快递方式</div>
            <div style="margin-top:30px;display:flex;justify-content:flex-start;flex-wrap:wrap" class="radio_cont">
              <el-radio
                      v-for="(itemName,i) in deliveryOptions"
                      :key='i'
                      class="el_radio_item"
                      v-model="subGoods.deliveryId"
                      :label="itemName.deliveryId"
                      border >
                {{ itemName.name }}
              </el-radio>
            </div>

            <div style="margin:30px 0 13px;color:#666">{{subGoods.subWarehouse.subWarehouseName}}备注</div>
            <el-input
                    type="textarea"
                    :rows="3"
                    placeholder="请输入备注"
                    v-model="subGoods.remark">
            </el-input>
        </div>
        </div>
          <div v-if="promotionStatus=='1'">
          <div style="margin:30px 0 13px;color:#666">优惠类型：
            <el-radio v-model="activityType" @change="activityTypeChange" label="1" border size="medium">促销活动</el-radio>
            <el-radio style="margin-left: 10px" v-model="activityType" @change="activityTypeChange" label="2" border size="medium">优惠券</el-radio>
          </div>
        </div>
        <div v-if="promotionStatus=='0'">
          <div style="margin:30px 0 13px;color:#666">使用优惠券</div>
        </div>

        <div style='border-bottom:1px solid #e4e4e4;width:100%;margin-bottom:13px;'></div>
        <div v-show="activityType=='1'">
          <el-button  style="width:200px;height:50px;background-color:#f9f9f9">
          当前优惠：¥{{promotionPrice}}
          </el-button>

        </div>
        <div v-show="activityType=='2'">
          <el-button  style="width:200px;height:50px;background-color:#f9f9f9"
            @click="conponOpen">
            <div v-if='couponItem'>
              当前优惠：¥{{ couponItem.apiCouponHistory.couponPrice }}
            </div>
            <div v-else> {{ coupon.length }} 张可用 </div>
          </el-button>

          <div style="margin-top:14px;font-size: 14px;color: #999999">
            共 <span style="color:#f90000">{{ coupon.length + unCoupon.length }}</span> 张优惠券，其中 <span style="color:#f90000">{{ coupon.length }}</span> 张可用
              <!-- <el-button style="margin-left:20px" type="text">兑换优惠券</el-button> -->
          </div>
        </div>



        <div style="margin:30px 0 13px;color:#666">金额明细</div>
        <div style='border-bottom:1px solid #e4e4e4;margin-bottom:13px;'></div>
        <div >
          <div style="line-height:30px;font-size: 14px;color: #666666;">
            商品件数：
            <span style="color:#D9001B;display:inline-block;float:right">{{ goodsNum }}&nbsp;件</span>
          </div>
          <div style="line-height:30px;font-size: 14px;color: #666666;">
            商品总价：
            <span style="color:#D9001B;display:inline-block;float:right">¥{{ goodsTotalPrice+resvPrice }}</span>
          </div>
          <div style="line-height:30px;font-size: 14px;color: #666666;">
            优惠金额：
            <span v-if="activityType=='2'" style="color:#D9001B;display:inline-block;float:right">-¥{{ couponItem ? couponItem.apiCouponHistory.couponPrice : 0 }}</span>
            <span v-if="activityType=='1'" style="color:#D9001B;display:inline-block;float:right">-¥{{ promotionPrice ? promotionPrice : 0 }}</span>
          </div>
          <div style="line-height:30px;font-size: 14px;color: #666666;"  v-if=" orderType == 1 ">
            预定优惠：
            <span style="color:#D9001B;display:inline-block;float:right">-¥{{ resvPrice ? resvPrice : 0 }}</span>
          </div>
          <div style="line-height:30px;font-size: 14px;color: #666666;">
            运费：
            <span style="color:#D9001B;display:inline-block;float:right">¥{{ order.postage ? order.postage : 0 }}</span>
          </div>
          <div style="line-height:30px;font-size: 14px;color: #666666;">
            应付总额：
            <span style="color:#D9001B;display:inline-block;font-size: 20px;font-weight: 700;float:right">¥{{ curPrice }}</span>
          </div>
        </div>

      </div>

      <div style="text-align:right;margin-top:30px">
        <div
          @click="createOrder"
          class="background_style btn"
          :style="{backgroundImage: 'url(' + btn_red + ')' }"
          style="display:inline-block;width:180px;height:44px;line-height:44px;cursor : pointer"
          v-if=" orderType == 0 "
        >
          立即结算
        </div>
        <div
          @click="askPaydate"
          class="background_style btn"
          :style="{backgroundImage: 'url(' + btn_red + ')' }"
          style="display:inline-block;width:180px;height:44px;line-height:44px;cursor : pointer"
          v-if=" orderType == 1 "
        >
          询问交货期
        </div>
      </div>

      <el-dialog
        class="pub_dialog"
        :title="addresstitle"
        center
        :visible.sync="addressVisible"
        width="55%"
      >
        <el-form :model="addressform" ref="addressform" :rules="addressrules">
          <el-form-item label="收货人姓名" :label-width="formLabelWidth"  prop="name" style="width:50%;display:inline-block">
            <el-input v-model="addressform.name" placeholder="请输入收货人姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机号" :label-width="formLabelWidth" prop="phone" style="width:50%;display:inline-block">
            <el-input maxlength="11" v-model="addressform.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="地区" :label-width="formLabelWidth" prop='proviceValue'>
            <el-cascader
              ref='proviceRef'
              v-model='addressform.proviceValue'
              style="width:100%"
              :options="proviceoptions"
              collapse-tags
              clearable
              @change="handleDistChange"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="详细地址" :label-width="formLabelWidth" prop="detail">
            <el-input
              v-model="addressform.detail"
              type="textarea"
              :rows="3"
              placeholder="请输入内容"
              style="height:80px"></el-input>
          </el-form-item>
          <el-form-item label="识别解析" :label-width="formLabelWidth">
            <el-input
              v-model="addressform.recdetail"
              :rows="3"
              placeholder="粘贴地址信息,自动识别姓名,电话和地址"
            >
              <template slot="append">
                <el-button slot="append" @click='recognitionClick'>点击识别</el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="是否为默认地址" :label-width="formLabelWidth">
            <el-switch
              v-model="addressform.isDefault"
              active-color="#f90000"
              inactive-color="#f0f0f0">
            </el-switch>
          </el-form-item>
          <el-form-item label="是否为代发地址" :label-width="formLabelWidth">
            <el-switch
              v-model="addressform.isForward"
              active-color="#f90000"
              inactive-color="#f0f0f0">
            </el-switch>
          </el-form-item>


        </el-form>
        <div slot="footer" class="dialog-footer">
          <div
            @click="addressVisible = false"
            class="background_style btn"
            :style="{backgroundImage: 'url(' + btn_black + ')' }"
            style="display:inline-block;margin-right:50px;cursor : pointer"
          >
            取 消
          </div>
          <div
            @click="submitAddress"
            class="background_style btn"
            :style="{backgroundImage: 'url(' + btn_red + ')' }"
            style="display:inline-block;cursor : pointer"
          >
            保 存
          </div>
        </div>
      </el-dialog>

      <el-dialog class="pub_dialog" title="选择收货地址" :visible.sync="addressChangeVisible" width="600" center>
        <div style="box-sizing:border-box;height:40px;display:flex">
          <el-input placeholder="请输入内容" v-model="input2" class="input-with-select" @keyup.enter.native="getUserAddressListSearch" style="flex:1;height:100%" clearable>
            <el-button slot="append"      @click="getUserAddressListSearch">搜索</el-button>
          </el-input>
        </div>

        <div style="height:350px;margin-top:20px;overflow-y:auto">
          <div
            class="addresslist_item"
            :class="{ 'addresslist_item_active': itemName.isSelected }"
            v-for="(itemName,i) in addressList"
            :key="i"
            style='cursor : pointer'
            @click="addresslist_item_click(i)"
          >
            <div style="display:flex;line-height:30px;">
              <div style="width:100px">收货人 :</div>
              <div style="color:#666666">{{ itemName.name }}</div>
            </div>

            <div style="display:flex;line-height:30px">
              <div style="width:100px">联系方式 : </div>
              <div style="color:#666666">{{ itemName.phone }} </div>
            </div>

            <div style="display:flex;line-height:30px">
              <div style="width:100px">收货地址 : </div>
              <div style="color:#666666;flex:1">{{itemName.provName + itemName.cityName+ itemName.distName +itemName.detail }}</div>
              <div v-show=' itemName.isDefault == 1 ' style="color:#f90000">
                默认地址
              </div>
            </div>
          </div>

        </div>

        <div slot="footer" class="dialog-footer">
          <div
            @click="addressChangeVisible = false"
            class="background_style btn"
            :style="{backgroundImage: 'url(' + btn_black + ')' }"
            style="display:inline-block;margin-right:50px;cursor : pointer"
          >
            取 消
          </div>
          <div
            @click="selectAddress"
            class="background_style btn"
            :style="{backgroundImage: 'url(' + btn_red + ')' }"
            style="display:inline-block;cursor : pointer"
          >
            确 定
          </div>
        </div>
      </el-dialog>

      <el-dialog class="pub_dialog" title="选择优惠券" :visible.sync="conponVisible" width="600" center>
        <div style="height:240px;margin-bottom:20px;overflow-y:auto"
          class="clear"
          v-if='coupon.length > 0' >
          <div
            class="conpon_item"
            v-for="(item,i) in coupon"
            :key="i"
            @click="conpon_item_click( i )"
            style='cursor : pointer'
          >
            <div
              :style="{backgroundImage: 'url(' + conpon_red + ')' }"
              style="width:119px;height:110px;background-size:cover"
            >
              <div style="font-size: 36px;font-weight: 700;color: #FFFFFF;text-align:center;margin-top:20px;margin-bottom:2px">
                {{ item.type == 1 ? item.reduceCost : item.discount/10 }}
                {{ item.type == 1 ? '元' : '折' }}
              </div>
              <div style="font-size: 12px;color: #FFFFFF;text-align:center">
                满{{  item.leastCost  }}元可用
              </div>
            </div>
            <div style="flex:1;margin-left:20px">
              <div style="font-size: 14px;font-weight: 700;color: #999999 ;margin-bottom:13px;margin-top:20px">
                {{ item.title }}
              </div>
              <div style="font-size: 12px;color: #CCCCCC;margin-bottom:10px">
                有效期从: {{ item.dateBegin  }}
              </div>
              <div style="font-size: 12px;color: #CCCCCC;margin-bottom:10px">
                有效期从: {{ item.dateEnd  }}
              </div>
            </div>
            <div
              :style="{backgroundImage: 'url(' + arrow + ')' }"
              class='conpon_item_arrow'
              v-show=" item.isSelected "
            >
            </div>
          </div>
        </div>

        <div style="font-size: 16px;color: #666666;padding-bottom:12px;border-bottom:1px solid #e4e4e4;margin-bottom:12px">
          以下不适用于此订单
        </div>
        <div style="height:240px;margin-bottom:20px;overflow-y:auto" class="clear">
          <div class="conpon_item"
            v-for="(item,i) in unCoupon"
            :key="i"
          >
            <div
              :style="{backgroundImage: 'url(' + conpon_gray + ')' }"
              style="width:119px;height:110px;background-size:cover"
            >
              <div style="font-size: 36px;font-weight: 700;color: #FFFFFF;text-align:center;margin-top:20px;margin-bottom:2px">
                {{ item.type == 1 ? item.reduceCost : item.discount/10 }}
                {{ item.type == 1 ? '元' : '折' }}
              </div>
              <div style="font-size: 12px;color: #FFFFFF;text-align:center">
                满{{  item.leastCost  }}元可用
              </div>
            </div>
            <div style="flex:1;margin-left:20px">
              <div style="font-size: 14px;font-weight: 700;color: #999999 ;margin-bottom:13px;margin-top:20px">
                {{ item.title }}
              </div>
              <div style="font-size: 12px;color: #CCCCCC;margin-bottom:10px">
                有效期从: {{ item.dateBegin  }}
              </div>
              <div style="font-size: 12px;color: #CCCCCC;margin-bottom:10px">
                有效期从: {{ item.dateEnd  }}
              </div>
            </div>
          </div>

        </div>

        <div style="text-align:center;" class="dialog-footer">
          <div
            @click="unUseCoupon "
            class="background_style btn"
            :style="{backgroundImage: 'url(' + btn_black + ')' }"
            style="display:inline-block;margin-right:50px;cursor : pointer"
          >
            不使用
          </div>
          <div
            @click="chooseCouponItem "
            class="background_style btn"
            :style="{backgroundImage: 'url(' + btn_red + ')' }"
            style="display:inline-block;cursor : pointer"
          >
            使用
          </div>
        </div>
      </el-dialog>
    </div>
  </div>

</template>

<script>
import { getCityReq } from "@/api/common/index";
import { getGoodsListReq  , getUseStatusCouponListReq  , getPostagePriceReq ,getPromotionPriceReq} from '@/api/OrderSettle/index'
import { addUserAddressReq , updateUserAddressReq , getDefaultUserAddressReq , getUserAddressReq , getUserAddressListReq , getDeliveryListReq , recognitionReq} from '@/api/userAddress/index'
import {  createOrderReq  } from '@/api/orderPay/index'


export default {
  data() {
    return {
      publicUrl : this.common.publicUrl ,
      // 图片信息
      btn_black_toggle: this.common.publicUrl + "/profile/avatar/u1939.png",
      btn_black_change : this.common.publicUrl + "/profile/avatar/u1940.png",
      btn_red : this.common.publicUrl + '/profile/avatar/u146.png' ,
      btn_black : this.common.publicUrl + '/profile/avatar/u147.png' ,
      conpon_red : this.common.publicUrl + '/profile/avatar/u1923.png' ,
      conpon_gray : this.common.publicUrl + '/profile/avatar/u1942.png' ,
      u1562 : this.common.publicUrl + '/profile/avatar/u1562.png' ,
      arrow : this.common.publicUrl + '/profile/avatar/u1905.png' ,
      // 图片信息

      deliveryOptions : [] ,
      delivery : '' ,
      input2 : '' ,
      addressVisible: false, //地址弹框显示
      proviceoptions : [] , //省市区数据
      proviceValue : '' , //省市区
      curPrice : 0 , //当前应付价格
      goodsNum : 0 , //件数
      promotionPrice : 0 , // 促销金额
      resvPrice : 0 , // 预定金额
      promotionHistoryId : null ,
      promotionStatus : '0' ,
      order : {} , //订单信息
      orderType : '' , //订单类型
      activityType : '1' , //优惠类型
      receiptType:'1', //收货选择
      formLabelWidth: '120px' ,
      addressChangeVisible : false ,//改变地址显示
      conponVisible : false , //选择优惠券显示
      remark : '' , //订单备注
      goods : [] , //商品信息
      subWarehouseGoods : [] , //商品信息
      goodsTotalPrice : 0 , //商品总价
      userDefaultAddress : {} ,//默认地址
      userAddress : {} ,//当前地址
      addresstitle : '' ,//地址title
      addressform: {  //地址数据

      },
      type : 0 ,
      addressList : [] , //地址列表

      // 表单验证
      addressrules : {
        name : [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { required: true, min: 2,  message: '字符至少为2位', trigger: 'blur' }
        ],
        phone : [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { required: true, min: 11, max: 11, message: '请输入正确手机号', trigger: 'blur' }
        ],
        proviceValue : [
          { required: true, message: '请选择地区', trigger: 'change' },
        ],
        detail : [
          { required: true, message: '请输入详细地址', trigger: 'blur' },
          { required: true, min: 5,  message: '地址需大于5位字符', trigger: 'blur' }
        ]
      } ,

      // 优惠券信息
      couponItem : false ,
      coupon :  [] ,
      unCoupon : [] ,
      // 优惠券信息

      tempOrderIds : '' ,
      isCartItem : '',
      verifyKey : '',

    };
  },
  computed: {
    moduleUser() {
      return this.$store.state.moduleUser; // 这里返回的是：{name: 'wang', age: 22}
    }
  },
  methods: {
    //重制表单数据
    reset(){
      this.addressform = {
        name: '',
        phone : '' ,
        proviceValue : [] ,
        detail : '' ,
        isDefault : false ,
        isForward : true ,
        recdetail : '' ,
      }
      this.resetForm("addressform");
    },
    //点击地址弹框
    addressClick(){
      this.reset();
      this.addresstitle = '新增收货地址'
      this.addressVisible = true

    },
    //切换地址
    addressChangeClick(){
      this.addressChangeVisible = true
      getUserAddressListReq({
        type : this.type ,

      }).then(res=>{
        if (res.data.status == 0) {
          let list = res.data.list
          list.forEach( ( val  )=> {
            val.isSelected = false
          })
          this.addressList = list

        }else{
          this.$message.error(res.data.statusDesc);
        }
      })
    } ,
    //查询地址
    getUserAddressListSearch(){
      getUserAddressListReq({
        type : this.type ,
        searchValue : this.input2 ,
      }).then(res=>{
        if (res.data.status == 0) {
          let list = res.data.list
          list.forEach( ( val  )=> {
            val.isSelected = false
          })
          this.addressList = list

        }else{
          this.$message.error(res.data.statusDesc);
        }
      })
    },


    //获取城市数据
    getCity(){
      getCityReq().then( res => {
        // console.log( res )
        this.proviceoptions = JSON.parse( res.data.city );
      } )
    } ,
    //省市区发生变化时
    handleDistChange(){
      // console.log( e )
      // console.log( this.$refs.proviceRef.getCheckedNodes()[0].pathLabels )
      let pathLabels = this.$refs.proviceRef.getCheckedNodes()[0].pathLabels ?this.$refs.proviceRef.getCheckedNodes()[0].pathLabels  : []
      this.addressform.provName = pathLabels[0]
      this.addressform.cityName = pathLabels[1]
      this.addressform.distName = pathLabels[2]
    },
    resetForm(formName) {
      this.$nextTick(()=>{
        this.$refs[formName].resetFields();
      })
    } ,
    //点击修改地址
    changeAddress(){
      if (Object.keys( this.userAddress ).length == 0) {
        this.$message('请先添加地址');
        return  // 如果为空,返回false
      }
      this.reset();
      this.addresstitle = '修改收货地址'
      this.addressVisible = true
      getUserAddressReq({
        addressId: this.userAddress.addressId
      }).then( res =>{
        if( res.data.status == 0 ){
          this.addressform.name = res.data.userAddress.name
          this.addressform.phone = res.data.userAddress.phone
          this.addressform.proviceValue = [ res.data.userAddress.provCode ,  res.data.userAddress.cityCode  , res.data.userAddress.distCode   ]
          this.addressform.provName = res.data.userAddress.provName
          this.addressform.cityName = res.data.userAddress.cityName
          this.addressform.distName = res.data.userAddress.distName

          this.addressform.detail =  res.data.userAddress.detail
          this.addressform.isDefault =  res.data.userAddress.isDefault == 1 ? true : false
          this.addressform.isForward =  res.data.userAddress.isForward == 1 ? true : false

          this.addressform.type = res.data.userAddress.type
          this.addressform.addressId = res.data.userAddress.addressId
        }else{
          this.$message.error(res.data.statusDesc);
        }
      })
      //
    },
    //切换地址选中项
    addresslist_item_click( i ){
      this.addressList.forEach( ( item , itx ) => {
        if( itx == i ){
          item.isSelected = true
        }else{
          item.isSelected = false
        }
      })
    },
    //选中地址
    selectAddress(){
      let isSelected = false
      let obj = { }
      this.addressList.forEach( ( item  ) => {
        if( item.isSelected ){  //有选中
          isSelected = true
          obj = item
        }
      })
      if( isSelected ){ //有选中地址
        this.userAddress = obj
        this.addressChangeVisible = false
      } else {
        this.$message.error('请选择收货地址');
      }
      this.getGoodsList();
    },
    // 提交地址
    submitAddress(){
      this.$refs["addressform"].validate(valid => {
        if (valid) {
          if( this.addresstitle == '新增收货地址' ){  //新增收货地址
            addUserAddressReq({
              name: this.addressform.name,
              phone : this.addressform.phone,
              provName : this.addressform.provName,
              provCode : this.addressform.proviceValue[0],
              cityName : this.addressform.cityName,
              cityCode : this.addressform.proviceValue[1],
              distName : this.addressform.distName,
              distCode : this.addressform.proviceValue[2],
              detail: this.addressform.detail,
              isDefault : this.addressform.isDefault ? 1 : 0 ,
              isForward : this.addressform.isForward ? 1 : 0 ,
              type :  this.type
            }).then( res => {
              if( res.data.status == 0 ){
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                getDefaultUserAddressReq({
                  type : 0
                }).then( response => {
                  this.userDefaultAddress = response.data.userAddress ? response.data.userAddress : {}
                  this.userAddress = response.data.userAddress  ? response.data.userAddress  : {}
                })
              }else{
                this.$message.error(res.data.statusDesc);
              }
              this.addressVisible = false

            })
          }else if( this.addresstitle == '修改收货地址' ){ //修改收货地址
            updateUserAddressReq({
              name: this.addressform.name,
              phone : this.addressform.phone,
              provName : this.addressform.provName,
              provCode : this.addressform.proviceValue[0],
              cityName : this.addressform.cityName,
              cityCode : this.addressform.proviceValue[1],
              distName : this.addressform.distName,
              distCode : this.addressform.proviceValue[2],

              detail: this.addressform.detail,
              isDefault : this.addressform.isDefault ? 1 : 0 ,
              isForward : this.addressform.isForward ? 1 : 0 ,
              type :  this.type ,
              addressId : this.addressform.addressId ,
            }).then( res => {
              if( res.data.status == 0 ){
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                getDefaultUserAddressReq({
                  type : 0
                }).then( response => {
                  this.userDefaultAddress = response.data.userAddress ? response.data.userAddress : {}
                  this.userAddress = response.data.userAddress  ? response.data.userAddress  : {}
                })
              }else{
                this.$message.error(res.data.statusDesc) ;
              }
              this.addressVisible = false
            })
          }

        }
      })
    } ,
    deliveryChange(){ //物流变化
      this.getPayPrice()
    },
    activityTypeChange(){ //物流变化
      this.getPayPrice()
    },
    receiptTypeChange(){
      this.getGoodsList()
    },
    getDeliveryList(){ //获取物流信息
      getDeliveryListReq().then( res => {
        if( res.data.status == 0 ){
          this.deliveryOptions = res.data.deliveries
        }else{
          this.$message.error(res.data.statusDesc);

        }
      })
    } ,
    getDefaultUserAddress(){ //获取默认收货地址
      return new Promise((resolve) => {
        getDefaultUserAddressReq({
          type : 0
        }).then( res => {
          if (res.data.status == 0) {
            this.userDefaultAddress = res.data.userAddress ? res.data.userAddress : {}
            this.userAddress = res.data.userAddress ? res.data.userAddress : {}
            resolve()
          }else{
            this.$message.error(res.data.statusDesc);
          }

        })
      })
    },
    getPromotionPrice(){ //获取促销规价格
      return new Promise((resolve) => {
        getPromotionPriceReq({
          isCartItem : this.isCartItem ,
          tempOrderIds : this.tempOrderIds ,
          orderType : this.orderType ,
        }).then( res => {
          if (res.data.status == 0) {
            this.promotionPrice = res.data.promotionPrice;
            this.promotionHistoryId = res.data.promotionHistoryId;
            this.promotionStatus = res.data.promotionStatus;
            if(this.promotionStatus=='0'){
              this.activityType= '2'
            }
            resolve()
          }else{
            this.$message.error(res.data.statusDesc);
          }

        })
      })
    },

    getGoodsList(){  //获取商品列表
      return new Promise((resolve) => {
        getGoodsListReq({  //请求商品列表
          isCartItem : this.isCartItem ,
          tempOrderIds : this.tempOrderIds ,
          orderType : this.orderType ,
          provCode:  this.userAddress.provCode,
          receiptType:this.receiptType ,
        }).then( (res)=>{
          if (res.data.status == 0) {
            this.goods =  res.data.goods
            this.subWarehouseGoods =  res.data.subWarehouseGoods
            let goodsNum =0;
            for(let i =0 ;i<this.goods.length;i++){
              goodsNum += this.goods[i].apiTempOrder.quantity
            }
            this.goodsNum = goodsNum;
            this.goodsTotalPrice = res.data.goodsTotalPrice
            this.resvPrice = res.data.resvPrice
            resolve()
          }else{
            this.$message.error(res.data.statusDesc);
          }
        })
      })
    } ,
    getUseStatusCouponList(){  //获取优惠券信息
      return new Promise( ( resolve ) => {
        getUseStatusCouponListReq({
          goodsTotlaPrice : this.goodsTotalPrice
        }).then( res => {
           if (res.data.status == 0) {
            let couponItem
            if( res.data.recommendHistoryId ){
              couponItem = {
                apiCouponHistory : {}
              }
              couponItem.apiCouponHistory.historyId = res.data.recommendHistoryId
              couponItem.apiCouponHistory.couponPrice = res.data.maxCouponPrice
            }else{
              couponItem = false
            }
            let coupon = []
            let unCoupon = []
            res.data.coupon.forEach( ( val  ) => {
              if( val.couponStatus == 0 ){
                val.isSelected = false
                coupon.push( val )
              }else if( val.couponStatus == 1 ){
                unCoupon.push( val  )
              }
            })
             let price1 = this.promotionPrice;
             let price2 = couponItem ? couponItem.apiCouponHistory.couponPrice : 0;
             if(price1 == 0 && price2 > 0){
                this.activityType= '2'
             }


            this.coupon =  coupon
            this.unCoupon = unCoupon
            this.couponItem = couponItem
            resolve()
           }else{
             this.$message.error(res.data.statusDesc);
           }
        } )
      } )
    } ,
    conponOpen(){
      this.getUseStatusCouponList()
      this.conponVisible = true
    },
    conpon_item_click(i){ //点击优惠券
      this.coupon.forEach( ( item , itx ) => {
        if( itx == i ){
          item.isSelected = true
        }else{
          item.isSelected = false
        }
      })
    } ,
    chooseCouponItem(){ //确定优惠券
      let isSelected = false
      let obj = { }
      this.coupon.forEach( ( item  ) => {
        if( item.isSelected ){  //有选中
          isSelected = true
          obj = item
        }
      })
      if( isSelected ){ //有选中地址
        this.couponItem = obj
        this.conponVisible = false
        this.getPayPrice()
      } else {
        this.$message.error('请选择优惠券');
      }

    },
    unUseCoupon(){ //不使用优惠券
      this.couponItem = false
      this.conponVisible = false
      this.getPayPrice()
    },
    getPayPrice(){ //获取相关费用
      return new Promise( ( resolve ) => {
        if (Object.keys( this.userAddress  ).length == 0) {
          this.$message('请先完善地址');
          return false // 如果为空,返回false
        }
        getPostagePriceReq({
          provName: this.userAddress.provName,
          cityName: this.userAddress.cityName,
          distName: this.userAddress.distName,
          historyId: this.couponItem ? this.couponItem.apiCouponHistory.historyId : '',
          deliveryId: this.delivery ? this.delivery : '' ,
          tempOrderIds :  this.tempOrderIds ,
          isCartItem : this.isCartItem ,
          orderType : this.orderType ,
        }).then( res => {
          if (res.data.status == 0) {
            this.order = res.data.order
            let goodsTotalPrice = this.goodsTotalPrice ? this.goodsTotalPrice : 0
            let postage = this.order.postage  ? this.order.postage : 0
            let couponPrice = 0;
            if(this.activityType=='1'){
              couponPrice =  this.promotionPrice;
            }else{
              couponPrice = this.couponItem ? this.couponItem.apiCouponHistory.couponPrice : 0
            }

            this.curPrice = ( goodsTotalPrice + postage - couponPrice ).toFixed(2)
          } else{
            this.$message( res.data.statusDesc  );
          }
          resolve()
        })

      })
    },
    createOrder(){ //创建订单
      let that = this
      if (!that.userAddress){
        this.$message({
          message: '请完善收货信息',
          type: 'warning'
        });
        return
      }
      // if (!that.delivery){
      //   this.$message({
      //     message: '请选择快递方式',
      //     type: 'warning'
      //   });
      //   return
      // }


      for(let i=0;i<this.subWarehouseGoods.length;i++){
        if(!this.subWarehouseGoods[i].deliveryId){
          this.$message({
            message: '请选择'+this.subWarehouseGoods[i].subWarehouse.subWarehouseName+'的快递方式',
            type: 'warning'
          })
          return
        }
      }

      let subWarehouseJson="";
      for(let i=0;i<this.subWarehouseGoods.length;i++){
        subWarehouseJson +="{deliveryId:'"+this.subWarehouseGoods[i].deliveryId+"',subWarehouseCode:'"+this.subWarehouseGoods[i].subWarehouse.subWarehouseCode
                +"',remark:'"+(this.subWarehouseGoods[i].remark==null?'':this.subWarehouseGoods[i].remark)+"'},";
      }
      subWarehouseJson ="["+subWarehouseJson.substring(0,subWarehouseJson.length-1)+"]";


      let obj = { }
      let goodsTotalPrice = this.goodsTotalPrice ?this.goodsTotalPrice : 0
      let postage = this.order.postage ? this.order.postage : 0
      let couponPrice = 0

      if(this.activityType==1){
        couponPrice =  this.promotionPrice;
        obj.historyId = this.promotionHistoryId;
      }else{
        couponPrice = this.couponItem ? this.couponItem.apiCouponHistory.couponPrice : 0
        obj.historyId = this.couponItem ? this.couponItem.apiCouponHistory.historyId : ''
      }

      obj.deliveryId =  this.delivery
      obj.orderType = this.orderType
      obj.postage = this.order.postage
      obj.name = this.userAddress.name
      obj.phone = this.userAddress.phone
      obj.provName = this.userAddress.provName
      obj.provCode = this.userAddress.provCode
      obj.cityName = this.userAddress.cityName
      obj.distName = this.userAddress.distName
      obj.detail = this.userAddress.detail
      obj.isForward = this.userAddress.isForward
      obj.tempOrderIds = this.tempOrderIds
      obj.isCartItem = this.isCartItem
      obj.payPrice = goodsTotalPrice  + postage - couponPrice
      obj.remark = this.remark
      obj.verifyKey = this.verifyKey
      obj.couponType = this.activityType
      obj.receiptType = this.receiptType
      obj.subWarehouseJson = subWarehouseJson
      obj = JSON.stringify(obj)

      this.$router.replace({
        path: '/orderPay',
        query: {
          params : obj
        }
      })
    },
    askPaydate(){ //询问交货期
      let that = this
      if (!that.userAddress){
        this.$message({
          message: '请完善收货信息',
          type: 'warning'
        });
        return
      }
      // if (!that.delivery){
      //   this.$message({
      //     message: '请完善物流信息',
      //     type: 'warning'
      //   });
      //   return
      // }


      for(let i=0;i<this.subWarehouseGoods.length;i++){
        if(!this.subWarehouseGoods[i].deliveryId){
          this.$message({
            message: '请选择'+this.subWarehouseGoods[i].subWarehouse.subWarehouseName+'的快递方式',
            type: 'warning'
          })
          return
        }
      }

      let subWarehouseJson="";
      for(let i=0;i<this.subWarehouseGoods.length;i++){
        subWarehouseJson +="{deliveryId:'"+this.subWarehouseGoods[i].deliveryId+"',subWarehouseCode:'"+this.subWarehouseGoods[i].subWarehouse.subWarehouseCode
                +"',remark:'"+(this.subWarehouseGoods[i].remark==null?'':this.subWarehouseGoods[i].remark)+"'},";
      }
      subWarehouseJson ="["+subWarehouseJson.substring(0,subWarehouseJson.length-1)+"]";


      let historyId;
      if(this.activityType==1){
        historyId = this.promotionHistoryId;
      }else{
        historyId = this.couponItem ? this.couponItem.apiCouponHistory.historyId : ''
      }
      createOrderReq({
        historyId: historyId,
        payChannel :  ''  ,
        orderType :  that.orderType ,
        receiptType :  that.receiptType ,
        deliveryId : that.delivery ,
        invoiceType :  0 ,
        invoiceProperty : 0 ,
        postage : that.order.postage ,
        name : that.userAddress.name ,
        phone :  that.userAddress.phone ,
        provName :  that.userAddress.provName ,
        provCode : that.userAddress.provCode,
        cityName : that.userAddress.cityName ,
        distName : that.userAddress.distName ,
        detail : that.userAddress.detail ,
        isForward : that.userAddress.isForward ,
        invoiceProvName : '',
        invoiceCityName : '' ,
        invoiceDistName : '' ,
        invoiceName : '' ,
        invoicePhone : '',
        invoiceDetail  : '' ,
        tempOrderIds : that.tempOrderIds ,
        isCartItem :  that.isCartItem ,
        remark : that.remark ,
        tradeType : 'NATIVE',
        couponType : that.activityType ,
        subWarehouseJson : subWarehouseJson ,
      }).then( res => {
        // console.log( res )
        if( res.data.status == 0 ){
          this.$router.replace({
            path: '/preorderSubmit'
          })
        }
      } )
    },
    recognitionClick(){
      if( !this.addressform.recdetail ){
        this.$message({
          message: '请输入正确地址信息',
          type: 'warning'
        });
        return
      }
      recognitionReq({  //请求商品列表
        text : this.addressform.recdetail ,
      }).then( (res)=>{
        if (res.data.status == 0) {
          this.addressform.name = res.data.userAddress.name ? res.data.userAddress.name : ''
          this.addressform.phone = res.data.userAddress.phone  ? res.data.userAddress.phone : ''
          if( res.data.userAddress.provCode ){
            this.addressform.proviceValue = [ res.data.userAddress.provCode, res.data.userAddress.cityCode, res.data.userAddress.distCode ]
            this.addressform.provName = res.data.userAddress.provName
            this.addressform.cityName = res.data.userAddress.cityName
            this.addressform.distName = res.data.userAddress.distName
          }else {
            this.addressform.proviceValue = []
            this.addressform.provName = ''
            this.addressform.cityName = ''
            this.addressform.distName = ''
          }
          this.addressform.detail = res.data.userAddress.detail  ? res.data.userAddress.detail : ''

        }else{
          this.$message({
            message: res.data.statusDesc,
            type: 'warning'
          });
        }
      })
    },

  } ,
  created(){

    this.getDeliveryList()    //获取物流信息
    this.getCity() //获取城市数据

    /*  结算信息赋值  */
    let obj =  JSON.parse( this.$route.query.params )
    this.tempOrderIds = obj.tempOrderIds.join( ',' )
    this.orderType = obj.orderType
    this.isCartItem = obj.isCartItem
    this.verifyKey = obj.verifyKey


    /*  结算信息赋值  */
    let p = new Promise((resolve ) => {
      this.getDefaultUserAddress().then( () =>{
        resolve()
      } )
    });
    p.then(() => {
      return new Promise((resolve) => {
        this.getGoodsList().then( () => {
          resolve()
        })
      })
    }).then(() => {
      return new Promise((resolve) => {
        this.getPromotionPrice().then( () =>{
          resolve()
        } )
      })
    }).then( ()=>{
      return new Promise((resolve) => {
        this.getUseStatusCouponList().then(() => {
          resolve()
        })
      })
    }).then( ()=> {
      return new Promise((resolve) => {
        this.getPayPrice().then(() => {
          resolve()
        })
      } )
    } )

  }
};
</script>

<style lang="stylus" scoped>
.cont {
  width: 1200px;
  color: #000;
  margin: 0 auto;
  box-sizing: border-box;
}
  .radio_cont  >>> .el-radio__input{
    display : none
  }
  .el_radio_item{
    width:250px;
    text-align:center;
    height:50px;
    line-height:25px;
    background-color:#f9f9f9;
    margin-left:10px;
    margin-right:10px;
    margin-bottom:10px
  }

  .pub_dialog {
    display: flex;
    justify-content: center;
    align-items: Center;
    overflow: hidden;
    .el-dialog {
        margin: 0 auto !important;
        height: 90%;
        overflow: hidden;
        .el-dialog__body {
            position: absolute;
            left: 0;
            top: 54px;
            bottom: 0;
            right: 0;
            padding: 0;
            z-index: 1;
            overflow: hidden;
            overflow-y: auto;
            .conpon_item{
              width 315px;
              height 110px;
              float left;
              border: 1px solid rgb(242, 242, 242);
              margin-bottom:20px
              margin-right:10px
              display:flex
              cursor:pointer
              position : relative
            }
              .conpon_item_arrow{
                position:absolute;right:0;bottom:0;width:47px;height:47px
              }
        }
    }
  }
  .addresslist_item{
    border:1px solid lightgray;
    padding:10px;
    margin-bottom:10px;
    font-size: 14px;
    color: #999999
  }
  .addresslist_item_active{
    border:1px solid #f90000;
  }

</style>
